import namespace from './namespace';
import { NAMESPACE as APP_NAMESPACE } from './../app';

let service;

export default {
    async [namespace.actions.GET_AVAILABLE_VALUES] ({ commit, dispatch }) {
        try {
            commit(namespace.mutations.SHOW_LOADER, true);
            let dataFromApi = await service.getData();
            commit(namespace.mutations.SET_MAPPINGS_VALUES, dataFromApi);
            commit(namespace.mutations.SHOW_LOADER, false);
            return dataFromApi;
        } catch (err) {
            dispatch(namespace.actions.HANDLE_ERROR, err);
        }
    },
    async [namespace.actions.GET_JIRA_VALUES] ({ commit, dispatch }, { query, filterMappedValues }) {
        try {
            let dataFromApi = await service.getJiraValues(query, filterMappedValues);
            commit(namespace.mutations.SET_JIRA_VALUES, dataFromApi);
            return dataFromApi;
        } catch (err) {
            dispatch(namespace.actions.HANDLE_ERROR, err);
        }
    },
    async [namespace.actions.MAP] ({ commit, state, dispatch }, payload) {
        try {
            commit(namespace.mutations.SHOW_LOADER, true);
            commit(namespace.mutations.SET_MAPPINGS_VALUES, await service.addMapping(
                payload.jiraValue,
                payload.tfsValue,
                state[namespace.state.AVAILABLE_VALUES],
                state[namespace.state.MAPPINGS]
            ));
            commit(namespace.mutations.SHOW_LOADER, false);
        } catch (err) {
            dispatch(namespace.actions.HANDLE_ERROR, err);
        }
    },
    async [namespace.actions.REMOVE_MAPPING] ({ commit, state, dispatch }, mappingObject) {
        try {
            mappingObject.duringProcessing = true;
            commit(namespace.mutations.SET_MAPPINGS_VALUES, await service.removeMapping(
                state[namespace.state.AVAILABLE_VALUES],
                state[namespace.state.MAPPINGS],
                mappingObject,
                true
            ));
        } catch (err) {
            dispatch(namespace.actions.HANDLE_ERROR, err);
        }
    },
    async [namespace.actions.SWITCH_TFS_LINK] ({ commit, state, dispatch }, mappingObject) {
        try {
            mappingObject.duringProcessing = true;
            commit(namespace.mutations.SET_MAPPINGS_VALUES, await service.switchTfsMapping(
                mappingObject,
                state[namespace.state.AVAILABLE_VALUES],
                state[namespace.state.MAPPINGS]));
        } catch (err) {
            dispatch(namespace.actions.HANDLE_ERROR, err);
        }
    },
    [namespace.actions.SET_UP_SERVICE] ({}, payload) {
        if (payload.service !== undefined) {
            service = payload.service;
        }
        if (payload.prefix !== undefined) {
            service.backendUrl = payload.prefix;
        }
    },
    [namespace.actions.HANDLE_ERROR] ({ commit, dispatch }, error) {
        commit(namespace.mutations.SHOW_LOADER, false);
        dispatch(APP_NAMESPACE.actions.HANDLE_ERROR, error, {root: true});
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/mappings/actions.js